<template>
    <div v-show="visible">
        <el-dialog title="优秀作业名单" :close-on-click-modal="false" v-loading="loading"  :visible.sync="visible" :before-close="dialogClose" width="750px">    
            <div class="container">
                 
                <el-table
                    :data="data"
                    style="width: 100%;margin-bottom: 20px;"
                    row-key="roleId"
                    height="350"
                    v-loading="loading"
                    element-loading-background = "rgba(255, 255,255,0.7)"
                    element-loading-text = "数据正在加载中..."
                    border fit highlight-current-row>
                    <!-- <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column> -->
                    <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                    <el-table-column prop="name" label="学生姓名"  :show-overflow-tooltip="true" width="100" ></el-table-column>
                    <el-table-column prop="className" label="班级名称"  width="100"></el-table-column>
                    <el-table-column prop="readSign" label="阅读标记" width="100">
                        <template slot-scope="scope">
                            <div v-if="scope.row.readSign == 1">
                                未读
                            </div>
                            <div v-else-if="scope.row.readSign == 2">
                                已读
                            </div>
                            <div v-else>
                                无
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="endSubmitTime" label="截止提交时间"  width="100">
                        <template slot-scope="scope">
                            <div v-if="scope.row.endSubmitTime != null && scope.row.endSubmitTime != ''">
                                {{scope.row.endSubmitTime}}
                            </div>
                            <div v-else>
                                无
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="content" label="提交作业内容" :show-overflow-tooltip="true" width="250"></el-table-column>
                    <el-table-column prop="commonSign" label="是否点评" width="100">
                        <template slot-scope="scope">
                            <div v-if="scope.row.commonSign == 0">
                                <span style="color:red">待点评</span>
                            </div>
                            <div v-else-if="scope.row.commonSign > 0">
                                已点评
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="taskSubmitTime" label="提交时间"  width="100"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="120" style="text-align:'left'">
                        <template slot-scope="scope">
                            <el-button
                                @click.native.prevent="showData(scope.row)"
                                type="text"
                                size="small" style="color: #387EE8;">
                                查看附件
                            </el-button>
                            <el-button v-if="scope.row.commonSign > 0"
                                @click.native.prevent="setCorrect(scope.row)"
                                type="text"
                                size="small" style="color: #387EE8;">
                                查看老师点评
                            </el-button>
                            <el-button style="color: red" @click.native.prevent="del(scope.row)"
                                type="text"
                                size="small">
                                删除优秀名单
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="pagination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="common.page"
                        :page-size="common.pageSize"
                        :page-sizes="common.allSizes"
                        layout="total,sizes, prev, pager, next, jumper"
                        :total="common.total">
                    </el-pagination>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="visible=false">关闭</el-button>
            </span>    
        </el-dialog>
        <!-- 查看附件弹出框 -->
        <div v-if="studentFileVisible">
            <studentFile ref="studentFile"></studentFile>
        </div>
        <!-- 查看老师点评弹出框 -->
        <div v-if="correctTaskVisible">
            <correctTask ref="correctTask"></correctTask>
        </div>
    </div>
</template>

<script>
    import http from '../../../common/http';
    import studentFile from './StudentFile.vue';
    import correctTask from './CorrectTask.vue';

    export default {
        data(){
            return{
                visible:false,
                loading:false,
                studentFileVisible:false,
                correctTaskVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    deptId:"",
                    taskListId:""
                },
                data:[],
                id:"",
                title:""
            }
        },
        components: {
            studentFile,correctTask
        },
        created:function () {
        },
        methods:{
            init(deptId,taskListId){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                // 重置姓名
                this.form.name="";
                // 赋值
                this.form.deptId=deptId;
                this.form.taskListId=taskListId;

                this.getData();
            },
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getData(){
                this.loading=true;
                let url  = this.fineTaskNameListUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    deptId:this.form.deptId,
                    taskListId:this.form.taskListId
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                        this.common.total=res.data.total;   
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }
                else{
                    return true;
                }
            },
           handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.fineTaskNameRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            showData(row){
                this.studentFileVisible=true;
                this.$nextTick(() => { 
                    this.$refs['studentFile'].init(this.form.deptId,row.id);
                })
            },
            setCorrect(row){
                this.correctTaskVisible=true;
                this.$nextTick(() => { 
                    this.$refs['correctTask'].init(this.form.deptId,row.id);
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/task/FineTaskName.vue